module.exports = __webpack_public_path__ + "img/Bunge North America, Inc.e7d7fea7.png";